import BaseResource from './BaseResource';
import { objectToUrlParams } from 'utils/params';

export default class FileShareResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  list(s = -1, includes = 'account') {
    const urlParams = objectToUrlParams({ s, includes });
    return super
      .get({ url: `${this.url}/share${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  share(accountId, access, includes = 'account') {
    const urlParams = objectToUrlParams({ access, includes });
    return super
      .post({}, { url: `${this.url}/share/${accountId}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  unshare(accountId) {
    return super
      .delete({ url: `${this.url}/share/${accountId}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  updateAccess(accountId, access, includes = 'account') {
    const urlParams = objectToUrlParams({ access, includes });
    return super
      .put({}, { url: `${this.url}/share/${accountId}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
